
<template>
  <div class="columns is-mobile is-full-height is-gapless" id="overall-content-wrapper">
    <!-- Sidebar -->

    <div id="sidebar" class="has-background-link flex-column" :class="sidebarClassObject">
      <!-- Logo -->
      <div
        id="sidebar"
        class="has-background-link flex-column bg"
        :class="[sidebarClassObject, backgroundColor]"
      >
        <div
          id="logo-wrapper"
          class="has-padding-top-25 has-padding-bottom-25 has-margin-bottom-10 flex-column align-items-center justify-center flex-row has-border-bottom-solid"
        >
          <b-icon icon="ferry" class="has-text-white"></b-icon>
          <div
            class="has-text-white has-padding-top-10 has-text-weight-bold has-letter-spacing-3 has-text-align-center is-size-7"
          >DANGEROUS GOODS PORTAL</div>
        </div>
        <div id="sidebar-links" class="has-flex-one">
          <template v-for="(item, index) in sidebarItems">
            <!-- Regular sidebar items with not dropdown items -->
            <template v-if="!item.isMultiLevel" @click="multilevelOpen = false">
              <div :key="index" @click="multilevelOpen = false">
                <router-link :to="item.link" class="sidebar-links" active-class="active-menu">
                  <b-icon :icon="item.icon" class="has-margin-right-15"></b-icon>
                  {{item.text}}
                </router-link>
              </div>
            </template>

            <!-- Sidebar items with dropdown menus -->
            <template v-if="item.isMultiLevel">
              <div class="nested-dropdown" :key="index" @click="multilevelOpen = true">
                <!-- Heading -->
                <div class="multilevel-header sidebar-links">
                  <b-icon :icon="item.icon" class="has-margin-right-15"></b-icon>
                  {{item.heading}}
                </div>

                <!-- Dropdown Links -->
                <div
                  class="multilevel-links-wrapper"
                  :class="dropDownClassObject"
                  @click="multilevelOpen = true"
                >
                  <router-link
                    v-for="(childItem, childIndex) in item.children"
                    :to="childItem.link"
                    :key="childIndex"
                    class="sidebar-links"
                    active-class="active-menu"
                  >
                    <b-icon :icon="childItem.icon" class="has-margin-right-5"></b-icon>
                    {{childItem.text}}
                  </router-link>
                </div>
              </div>
            </template>
          </template>

          <div class="has-margin-top-30 has-padding-20 has-text-white">
            <b-icon :icon="'logout'" class="has-margin-right-15"></b-icon>
            <a
              href="#"
              class="has-text-white has-margin-top-30 is-size-6"
              @click.prevent="logout"
            >LOGOUT</a>
          </div>
        </div>
      </div>
    </div>
    <!-- EOF Sidebar -->

    <!-- Main Content -->
    <div
      id="mainContent"
      class="column is-full-height is-flex flex-column"
      :class="contentClassObject"
    >
      <!-- Sidebar Toggle -->
      <div class="flex-header">
        <div class="toggle has-border-right" @click="toggleSidebar">
          <b-icon icon="menu" size="is-medium" type="is-primary"></b-icon>
        </div>
        <div class="dashboard-i">
          <div>
            <span type="is-primary">{{currentDashboard}}</span>
          </div>
        </div>
      </div>

      <!-- Slot for content from component which uses this layout -->
      <div
        class="is-full-width has-flex-one is-fluid has-padding-left-30 has-padding-right-30 has-padding-top-10 has-padding-bottom-20 has-max-width-1500 has-margin-0-auto"
      >
        <slot name="mainContent"></slot>
      </div>

      <!-- Footer -->

      <div>
        <div class="img_banner has-padding-5">
          <img
            class="has-default-logo--style"
            src="../../../assets/nimasa-logo.png"
            alt="nimasa logo"
          >
          <img class="has-default-logo--style has-padding-right-40" src="https://nimasa.gov.ng/wp-content/uploads/2019/09/2000px-Coat_of_arms_of_Nigeria.svg.png" alt="coat of arms">
        </div>

        <ul class="footer flex-row has-background-green">
          <li>
            <div class="link has-text-light is-size-7" @click="supportForm" >Contact Support</div>
          </li>
          <li>
            <div class=" has-text-light is-size-7" >Legal</div>
          </li>
        </ul>
      </div>
    </div>
    <!-- EOF Main Content -->
  </div>
</template>

<script>
import SupportFormModal from "@/modules/commonModule/layouts/SupportForm"
import { resetLocalStorage } from "@/store/index";
import { mapState, mapMutations as mapRootMutations } from "vuex";
import {
  ROOT_MUTATION_TYPES,
  SHIPPER_MUTATION_TYPES
} from "@/store/mutation-types";
import isObject from "../helpers/isObject";
import { createNamespacedHelpers } from "vuex";
const { mapMutations } = createNamespacedHelpers("shippers");
export default {
  name: "SidebarLayout",
  props: {
    sidebarItems: { type: Array, required: true }
  },
  data() {
    return {
      sidebarCollapsed: false,
      multilevelOpen: false,
      isSupportFormActive: false
    };
  },
  mounted() {
    //keep the drop down open on refresh, add new drop down route names here to keep them open
    if (
      this.$route.name === "nimasa-active-ports-report" ||
      this.$route.name === "nimasa-dangerous-goods-report"
    ) {
      this.multilevelOpen = true;
    }
  },

  methods: {
    ...mapRootMutations({
      toggleSidebar: ROOT_MUTATION_TYPES.TOGGLE_SIDEBAR,
      resetRootState: ROOT_MUTATION_TYPES.RESET_STATE
    }),
    ...mapMutations({
      resetShipperState: SHIPPER_MUTATION_TYPES.RESET_STATE
    }),
    isObject(variable) {
      return isObject(variable);
    },
    logout() {
      resetLocalStorage();
      this.resetRootState();
      this.resetShipperState();
      this.$router.push("/");
    },
    supportForm(){
      this.$modal.open({
        parent: this,
        component: SupportFormModal,
        hasModalCard: true
      })
    }
  },
  computed: {
    ...mapState({
      sidebarOpen: state => state.sidebarOpen
    }),
    sidebarClassObject: function() {
      return {
        "column is-narrow has-width-250": this.sidebarOpen,
        "no-width": !this.sidebarOpen
      };
    },
    contentClassObject: function() {
      return {};
    },
    backgroundColor: function() {
      const url = this.$route.path.split("/")[1];
      switch (url) {
        case "shipper":
          return "shipper-background";
          break;
        case "port":
          return "port-background";
          break;
        case "nimasa-agent":
          return "nimasa-agent-background";
          break;
        default:
          return "background";
          break;
      }
    },
    currentDashboard: function() {
      const user = this.$store.getters.getUserDetails;
      //return the user with the port name
      if(user.user_port){
        return `Welcome ${user.full_name}, ${user.user_port.name}`
      }else {
      return `Welcome ${user.full_name}`;
      }
    
    },
    dropDownClassObject: function() {
      return {
        openDropDown: this.multilevelOpen
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.multilevel-links-wrapper {
  display: none;
  margin: 10px 0px;
  a {
    display: flex;
    align-items: center;
    padding-left: 35px;

    &:hover {
      opacity: 0.9;
      background-color: rgba(0, 0, 0, 0.1);
      border-left: 4px solid white;
      color: white !important;
      cursor: pointer;
      transition: border cubic-bezier(0.075, 0.82, 0.165, 1) 0.3s;
    }
  }
}

.nested-dropdown {
  &:hover {
    .multilevel-links-wrapper {
      display: block;
    }
  }
}

.openDropDown {
  display: block;
}

#sidebar,
#mainContent {
  transition: width 0.5s;
}

#sidebar {
  padding: 0 !important;
}

#overall-content-wrapper {
  background: #f5faff;
}

.bg-d {
  background-color: darkblue;
}
.bg {
  position: fixed;
  height: 100vh;
}
.sidebar-links {
  padding: 10px 10px;
  display: flex;
  align-items: center;
  text-transform: uppercase;
  font-size: 0.8em;
  color: rgba(256, 256, 256, 0.7) !important;
  &:hover {
    opacity: 0.9;
    background-color: rgba(0, 0, 0, 0.1);
    border-left: 4px solid white;
    color: white !important;
    cursor: pointer;
    transition: border cubic-bezier(0.075, 0.82, 0.165, 1) 0.3s;
  }
}
.no-width {
  width: 0;
  height: 0;
  opacity: 0;
}
.toggle {
  cursor: pointer;
  z-index: 10;
  padding: 9px 15px;
}
.active-menu {
  background-color: rgba(0, 0, 0, 0.1);
  border-left: 4px solid white;
  color: white !important;
  font-weight: bold !important;
}
.footer {
  padding: 5px;
  li {
    margin: 1px 10px;
  }
  li > a {
    color: white;
    font-size: 12px;
  }
}
#overall-content-wrapper {
  overflow-y: scroll;
  overflow-x: hidden;
}
.background {
  background-color: #009adb !important;
}
.shipper-background {
  background-color: #009adb !important;
}
.nimasa-agent-background {
  background-color: #009adb !important;
}
.port-background {
  background-color: #009adb !important;
}
.flex-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid lightgrey;
}
.dashboard-i {
  text-align: right;
  padding: 7px;
}
.dashboard-i span {
  font-size: 18px;
  margin-right: 20px;
  font-weight: 700;
}
.img_banner {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background-color: white;
}
.link {
  cursor: pointer;
}
</style>

